export enum FavoriteStoreUpdateMode {
    Remove = 'remove',
}
